// // components/TrackingScreen.tsx
// import React, { useState } from 'react';
// import { 
//   Truck, 
//   Package, 
//   Calendar, 
//   Clock, 
//   CheckCircle,
//   MapPin,
//   Home,
//   Warehouse
// } from 'lucide-react';

// // Define primary color
// const PRIMARY_COLOR = '#3498db';
// const SUCCESS_COLOR = '#2ecc71';
// const GRAY_COLOR = '#95a5a6';
// const LIGHT_BG = '#f8fafc';
// const BORDER_COLOR = '#e5e7eb';
// const TEXT_PRIMARY = '#1f2937';
// const TEXT_SECONDARY = '#6b7280';

// interface TrackingEvent {
//   id: string;
//   title: string;
//   description: string;
//   date: string;
//   time: string;
//   completed: boolean;
//   current: boolean;
//   icon: React.ReactNode;
// }

// const TrackingScreen: React.FC = () => {
//   const [trackingId, setTrackingId] = useState<string>('INS-2024-789456');
//   const [deliveryType, setDeliveryType] = useState<'door' | 'godown'>('door');
  
//   // Timeline data
//   const timelineEvents: TrackingEvent[] = [
//     {
//       id: '1',
//       title: 'Pickup Scheduled',
//       description: 'Package picked up from sender',
//       date: '15 Jan 2024',
//       time: '10:30 AM',
//       completed: true,
//       current: false,
//       icon: <Package size={20} />
//     },
//     {
//       id: '2',
//       title: 'In Transit',
//       description: 'Package is on its way',
//       date: '16 Jan 2024',
//       time: '02:15 PM',
//       completed: true,
//       current: true,
//       icon: <Truck size={20} />
//     },
//     {
//       id: '3',
//       title: 'Estimated Delivery',
//       description: 'Expected delivery date',
//       date: '20 Jan 2024',
//       time: 'By EOD',
//       completed: false,
//       current: false,
//       icon: <Calendar size={20} />
//     }
//   ];

//   const containerStyle: React.CSSProperties = {
//     minHeight: '100vh',
//     backgroundColor: LIGHT_BG,
//     padding: '20px',
//     fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
//   };

//   const cardStyle: React.CSSProperties = {
//     backgroundColor: 'white',
//     borderRadius: '12px',
//     boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
//     padding: '24px',
//     marginBottom: '20px',
//     border: `1px solid ${BORDER_COLOR}`
//   };

//   const headerStyle: React.CSSProperties = {
//     textAlign: 'center',
//     marginBottom: '40px',
//     paddingBottom: '20px',
//     borderBottom: `1px solid ${BORDER_COLOR}`
//   };

//   const titleStyle: React.CSSProperties = {
//     fontSize: '32px',
//     fontWeight: 600,
//     color: TEXT_PRIMARY,
//     marginBottom: '8px',
//     letterSpacing: '-0.5px'
//   };

//   const subtitleStyle: React.CSSProperties = {
//     fontSize: '16px',
//     color: TEXT_SECONDARY,
//     fontWeight: 400
//   };

//   const timelineContainerStyle: React.CSSProperties = {
//     position: 'relative',
//     maxWidth: '600px',
//     margin: '0 auto',
//     padding: '20px 0'
//   };

//   const timelineLineStyle: React.CSSProperties = {
//     position: 'absolute',
//     left: '30px',
//     top: '0',
//     bottom: '0',
//     width: '2px',
//     backgroundColor: BORDER_COLOR
//   };

//   const timelineItemStyle: React.CSSProperties = {
//     position: 'relative',
//     marginBottom: '40px',
//     display: 'flex',
//     alignItems: 'flex-start',
//     minHeight: '60px'
//   };

//   const iconContainerStyle = (completed: boolean, current: boolean): React.CSSProperties => ({
//     width: '60px',
//     height: '60px',
//     borderRadius: '50%',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     marginRight: '20px',
//     backgroundColor: completed ? PRIMARY_COLOR : 'white',
//     border: `2px solid ${completed ? PRIMARY_COLOR : BORDER_COLOR}`,
//     position: 'relative',
//     zIndex: 2,
//     boxShadow: current ? `0 0 0 4px rgba(52, 152, 219, 0.2)` : 'none',
//     transition: 'all 0.3s ease'
//   });

//   const contentStyle: React.CSSProperties = {
//     flex: 1,
//     paddingTop: '8px'
//   };

//   const eventTitleStyle: React.CSSProperties = {
//     fontSize: '18px',
//     fontWeight: 600,
//     color: TEXT_PRIMARY,
//     marginBottom: '4px'
//   };

//   const eventDescStyle: React.CSSProperties = {
//     fontSize: '14px',
//     color: TEXT_SECONDARY,
//     marginBottom: '8px'
//   };

//   const timeStyle: React.CSSProperties = {
//     fontSize: '13px',
//     color: GRAY_COLOR,
//     display: 'flex',
//     alignItems: 'center',
//     gap: '6px'
//   };

//   const deliveryTypeCardStyle: React.CSSProperties = {
//     ...cardStyle,
//     textAlign: 'center',
//     maxWidth: '400px',
//     margin: '40px auto'
//   };

//   const deliveryTypeTitleStyle: React.CSSProperties = {
//     fontSize: '18px',
//     fontWeight: 600,
//     color: TEXT_PRIMARY,
//     marginBottom: '16px'
//   };

//   const deliveryTypeOptionsStyle: React.CSSProperties = {
//     display: 'flex',
//     gap: '16px',
//     justifyContent: 'center'
//   };

//   const deliveryOptionStyle = (type: 'door' | 'godown', selected: boolean): React.CSSProperties => ({
//     flex: 1,
//     padding: '20px 16px',
//     borderRadius: '8px',
//     border: `2px solid ${selected ? PRIMARY_COLOR : BORDER_COLOR}`,
//     backgroundColor: selected ? 'rgba(52, 152, 219, 0.05)' : 'white',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     gap: '8px'
//   });

//   const deliveryIconStyle = (selected: boolean): React.CSSProperties => ({
//     color: selected ? PRIMARY_COLOR : GRAY_COLOR,
//     marginBottom: '8px'
//   });

//   const deliveryLabelStyle: React.CSSProperties = {
//     fontSize: '14px',
//     fontWeight: 500,
//     color: TEXT_PRIMARY
//   };

//   const statusBadgeStyle: React.CSSProperties = {
//     display: 'inline-block',
//     padding: '6px 12px',
//     backgroundColor: 'rgba(52, 152, 219, 0.1)',
//     color: PRIMARY_COLOR,
//     borderRadius: '20px',
//     fontSize: '13px',
//     fontWeight: 500,
//     marginLeft: '12px'
//   };

//   return (
//     <div style={containerStyle}>
//       <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        
//         {/* Header */}
//         <div style={headerStyle}>
//           <h1 style={titleStyle}>Package Tracking</h1>
//           <p style={subtitleStyle}>Track your shipment in real-time</p>
//         </div>

//         {/* Timeline */}
//         <div style={cardStyle}>
//           {/* Tracking ID */}
//           <div style={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             marginBottom: '40px',
//             paddingBottom: '20px',
//             borderBottom: `1px solid ${BORDER_COLOR}`
//           }}>
//             <div>
//               <div style={{ fontSize: '14px', color: TEXT_SECONDARY, marginBottom: '4px' }}>
//                 Tracking Number
//               </div>
//               <div style={{ 
//                 fontSize: '18px', 
//                 fontWeight: 600, 
//                 color: TEXT_PRIMARY,
//                 fontFamily: "'Monaco', 'Consolas', monospace"
//               }}>
//                 {trackingId}
//               </div>
//             </div>
//             <div style={statusBadgeStyle}>
//               In Transit
//             </div>
//           </div>

//           {/* Timeline */}
//           <div style={timelineContainerStyle}>
//             <div style={timelineLineStyle} />
            
//             {timelineEvents.map((event) => (
//               <div key={event.id} style={timelineItemStyle}>
//                 <div style={iconContainerStyle(event.completed, event.current)}>
//                   {React.cloneElement(event.icon as React.ReactElement, {
//                     // color: event.completed ? 'white' : event.current ? PRIMARY_COLOR : GRAY_COLOR,
//                     // size: 24
//                   })}
//                   {event.completed && (
//                     <CheckCircle 
//                       size={16} 
//                       color="white"
//                       style={{
//                         position: 'absolute',
//                         bottom: '-2px',
//                         right: '-2px',
//                         backgroundColor: SUCCESS_COLOR,
//                         borderRadius: '50%'
//                       }}
//                     />
//                   )}
//                 </div>
                
//                 <div style={contentStyle}>
//                   <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
//                     <h3 style={eventTitleStyle}>{event.title}</h3>
//                     {event.current && (
//                       <span style={{
//                         ...statusBadgeStyle,
//                         backgroundColor: 'rgba(52, 152, 219, 0.1)',
//                         color: PRIMARY_COLOR,
//                         fontSize: '11px',
//                         padding: '4px 8px',
//                         marginLeft: '8px'
//                       }}>
//                         Current
//                       </span>
//                     )}
//                   </div>
//                   <p style={eventDescStyle}>{event.description}</p>
//                   <div style={timeStyle}>
//                     <Calendar size={12} />
//                     <span>{event.date}</span>
//                     <Clock size={12} style={{ marginLeft: '12px' }} />
//                     <span>{event.time}</span>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* Delivery Progress */}
//           <div style={{
//             marginTop: '40px',
//             paddingTop: '20px',
//             borderTop: `1px solid ${BORDER_COLOR}`
//           }}>
//             <div style={{ 
//               display: 'flex', 
//               justifyContent: 'space-between',
//               alignItems: 'center',
//               marginBottom: '12px' 
//             }}>
//               <span style={{ fontSize: '14px', color: TEXT_SECONDARY }}>Progress</span>
//               <span style={{ fontSize: '14px', fontWeight: 500, color: PRIMARY_COLOR }}>66%</span>
//             </div>
//             <div style={{
//               height: '6px',
//               backgroundColor: BORDER_COLOR,
//               borderRadius: '3px',
//               overflow: 'hidden'
//             }}>
//               <div style={{
//                 width: '66%',
//                 height: '100%',
//                 backgroundColor: PRIMARY_COLOR,
//                 borderRadius: '3px',
//                 transition: 'width 0.3s ease'
//               }} />
//             </div>
//           </div>
//         </div>

//         {/* Delivery Type */}
//         <div style={deliveryTypeCardStyle}>
//           <h3 style={deliveryTypeTitleStyle}>Delivery Type</h3>
//           <div style={deliveryTypeOptionsStyle}>
//             <div 
//               style={deliveryOptionStyle('door', deliveryType === 'door')}
//               onClick={() => setDeliveryType('door')}
//               onMouseEnter={(e) => {
//                 if (deliveryType !== 'door') {
//                   e.currentTarget.style.borderColor = PRIMARY_COLOR;
//                   e.currentTarget.style.backgroundColor = 'rgba(52, 152, 219, 0.02)';
//                 }
//               }}
//               onMouseLeave={(e) => {
//                 if (deliveryType !== 'door') {
//                   e.currentTarget.style.borderColor = BORDER_COLOR;
//                   e.currentTarget.style.backgroundColor = 'white';
//                 }
//               }}
//             >
//               <Home size={24} style={deliveryIconStyle(deliveryType === 'door')} />
//               <span style={deliveryLabelStyle}>Door Delivery</span>
//               <span style={{ fontSize: '13px', color: TEXT_SECONDARY, textAlign: 'center' }}>
//                 Delivered to your doorstep
//               </span>
//             </div>
            
//             <div 
//               style={deliveryOptionStyle('godown', deliveryType === 'godown')}
//               onClick={() => setDeliveryType('godown')}
//               onMouseEnter={(e) => {
//                 if (deliveryType !== 'godown') {
//                   e.currentTarget.style.borderColor = PRIMARY_COLOR;
//                   e.currentTarget.style.backgroundColor = 'rgba(52, 152, 219, 0.02)';
//                 }
//               }}
//               onMouseLeave={(e) => {
//                 if (deliveryType !== 'godown') {
//                   e.currentTarget.style.borderColor = BORDER_COLOR;
//                   e.currentTarget.style.backgroundColor = 'white';
//                 }
//               }}
//             >
//               <Warehouse size={24} style={deliveryIconStyle(deliveryType === 'godown')} />
//               <span style={deliveryLabelStyle}>Godown Delivery</span>
//               <span style={{ fontSize: '13px', color: TEXT_SECONDARY, textAlign: 'center' }}>
//                 Pick up from warehouse
//               </span>
//             </div>
//           </div>
//         </div>

//         {/* Simple Footer */}
//         <div style={{
//           textAlign: 'center',
//           marginTop: '40px',
//           paddingTop: '20px',
//           borderTop: `1px solid ${BORDER_COLOR}`,
//           color: TEXT_SECONDARY,
//           fontSize: '13px'
//         }}>
//           <p>Need help? Contact support@instaship.co.in</p>
//           <p style={{ marginTop: '4px', fontSize: '12px', opacity: 0.8 }}>
//             Tracking updates every 30 minutes
//           </p>
//         </div>
//       </div>

//       {/* Add smooth hover effects */}
//       <style>
//         {`
//           @keyframes fadeIn {
//             from { opacity: 0; transform: translateY(10px); }
//             to { opacity: 1; transform: translateY(0); }
//           }
          
//           * {
//             box-sizing: border-box;
//           }
          
//           body {
//             margin: 0;
//             font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
//           }
          
//           .timeline-item {
//             animation: fadeIn 0.5s ease-out;
//           }
          
//           .delivery-option:hover {
//             transform: translateY(-2px);
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// export default TrackingScreen;































// import React, { useState } from 'react';
// import './TrackingScreen.css';

// type DeliveryType = 'GODOWN_DELIVERY' | 'DOOR_DELIVERY';
// type Status = 'pickup' | 'intransit' | 'delivered';

// interface OrderStatus {
//   lrn: string;
//   status: Status;
//   pickupDate: string;
//   estimatedDelivery?: string;
//   deliveredOn?: string;
//   fromCity: string;
//   toCity: string;
//   deliveryType: DeliveryType;
// }

// const dummyOrders: OrderStatus[] = [
//   {
//     lrn: 'LRN001234',
//     status: 'pickup',
//     pickupDate: '2025-12-05',
//     estimatedDelivery: '2025-12-08',
//     fromCity: 'Delhi',
//     toCity: 'Jaipur',
//     deliveryType: 'GODOWN_DELIVERY',
//   },
//   {
//     lrn: 'LRN005678',
//     status: 'intransit',
//     pickupDate: '2025-12-03',
//     estimatedDelivery: '2025-12-06',
//     fromCity: 'Noida',
//     toCity: 'Ludhiana',
//     deliveryType: 'DOOR_DELIVERY',
//   },
//   {
//     lrn: 'LRN009012',
//     status: 'delivered',
//     pickupDate: '2025-12-01',
//     deliveredOn: '2025-12-03',
//     fromCity: 'Gurgaon',
//     toCity: 'Mumbai',
//     deliveryType: 'DOOR_DELIVERY',
//   },
// ];

// const TrackingScreen: React.FC = () => {
//   const [lrnInput, setLrnInput] = useState('');
//   const [trackingResult, setTrackingResult] = useState<OrderStatus | null>(null);
//   const [notFound, setNotFound] = useState(false);
//   const [searched, setSearched] = useState(false);

//   const handleTrack = () => {
//     if (!lrnInput.trim()) return;

//     const order = dummyOrders.find(
//       o => o.lrn.toLowerCase() === lrnInput.trim().toLowerCase()
//     );

//     setSearched(true);
//     if (order) {
//       setTrackingResult(order);
//       setNotFound(false);
//     } else {
//       setTrackingResult(null);
//       setNotFound(true);
//     }
//   };

//   const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
//     if (e.key === 'Enter') handleTrack();
//   };

//   const formatDate = (dateString?: string) => {
//     if (!dateString) return '-';
//     const d = new Date(dateString);
//     return d.toLocaleDateString('en-IN', {
//       day: 'numeric',
//       month: 'short',
//       year: 'numeric',
//     });
//   };

//   const currentStep = (status: Status) => {
//     if (status === 'pickup') return 1;
//     if (status === 'intransit') return 2;
//     if (status === 'delivered') return 3;
//     return 0;
//   };

//   const getDeliveryTypeLabel = (deliveryType: DeliveryType) =>
//     deliveryType === 'GODOWN_DELIVERY' ? 'Godown delivery' : 'Door delivery';

//   return (
//     <div className="tracking-page">
//       <div className="tracking-header">
//         <h1 className="tracking-title">Track shipment</h1>
//         <p className="tracking-subtitle">
//           Check live status, route and expected delivery for your Instaship load.
//         </p>
//       </div>

//       <div className="tracking-search-card">
//         <div className="search-row">
//           <input
//             type="text"
//             className="lrn-input"
//             placeholder="Enter LRN number"
//             value={lrnInput}
//             onChange={e => setLrnInput(e.target.value.toUpperCase())}
//             onKeyDown={handleKeyDown}
//           />
//           <button className="track-button" onClick={handleTrack}>
//             Track
//           </button>
//         </div>
//         {searched && (
//           <button
//             className="reset-button"
//             onClick={() => {
//               setLrnInput('');
//               setTrackingResult(null);
//               setNotFound(false);
//               setSearched(false);
//             }}
//           >
//             Clear
//           </button>
//         )}
//       </div>

//       {notFound && (
//         <div className="status-card not-found">
//           <h3>Shipment not found</h3>
//           <p>
//             No shipment could be found for LRN <strong>{lrnInput}</strong>.
//           </p>
//           <p>
//             Please verify the LRN or contact{' '}
//             <a href="mailto:support@instaship.co.in">support@instaship.co.in</a>.
//           </p>
//         </div>
//       )}

//       {trackingResult && (
//         <div className="status-card">
//           <div className="status-top-row">
//             <div className="status-pill-row">
//               <span className="pill pill-status">
//                 {trackingResult.status === 'delivered'
//                   ? 'Delivered'
//                   : trackingResult.status === 'intransit'
//                   ? 'In transit'
//                   : 'Pickup scheduled'}
//               </span>
//               <span className="pill pill-type">
//                 {getDeliveryTypeLabel(trackingResult.deliveryType)}
//               </span>
//             </div>
//             <div className="lrn-chip">LRN • {trackingResult.lrn}</div>
//           </div>

//           {/* Route chip */}
//           <div className="route-chip">
//             <div className="route-locations">
//               <span className="route-city route-city--from">
//                 {trackingResult.fromCity}
//               </span>
//               <span className="route-arrow">→</span>
//               <span className="route-city route-city--to">
//                 {trackingResult.toCity}
//               </span>
//             </div>
//             <span className="route-meta">
//               {trackingResult.status === 'delivered'
//                 ? 'Delivered on ' + formatDate(trackingResult.deliveredOn)
//                 : 'ETA ' + formatDate(trackingResult.estimatedDelivery)}
//             </span>
//           </div>

//           {/* Minimal progress bar timeline */}
//           <div className="timeline-wrapper">
//             <div className="timeline-bar">
//               <div
//                 className="timeline-bar-fill"
//                 style={{ width: `${(currentStep(trackingResult.status) - 1) * 50}%` }}
//               />
//             </div>
//             <div className="timeline-steps">
//               <div
//                 className={`timeline-step ${
//                   currentStep(trackingResult.status) >= 1 ? 'active' : ''
//                 }`}
//               >
//                 <div className="timeline-step-dot" />
//                 <div className="timeline-step-label">Pickup date</div>
//                 <div className="timeline-step-value">
//                   {formatDate(trackingResult.pickupDate)}
//                 </div>
//               </div>

//               <div
//                 className={`timeline-step ${
//                   currentStep(trackingResult.status) >= 2 ? 'active' : ''
//                 }`}
//               >
//                 <div className="timeline-step-dot" />
//                 <div className="timeline-step-label">In transit</div>
//                 <div className="timeline-step-value">
//                   Package is on its way
//                 </div>
//               </div>

//               <div
//                 className={`timeline-step ${
//                   currentStep(trackingResult.status) >= 3 ? 'active' : ''
//                 }`}
//               >
//                 <div className="timeline-step-dot" />
//                 <div className="timeline-step-label">
//                   {trackingResult.status === 'delivered'
//                     ? 'Delivered on'
//                     : 'Estimated delivery by'}
//                 </div>
//                 <div className="timeline-step-value">
//                   {trackingResult.status === 'delivered'
//                     ? formatDate(trackingResult.deliveredOn)
//                     : formatDate(trackingResult.estimatedDelivery)}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default TrackingScreen;



















// import React, { useState } from 'react';
// import './TrackingScreen.css';

// type DeliveryType = 'GODOWN_DELIVERY' | 'DOOR_DELIVERY';
// type Status = 'pickup' | 'intransit' | 'delivered';

// interface OrderStatus {
//   lrn: string;
//   status: Status;
//   pickupDate: string;
//   estimatedDelivery?: string;
//   deliveredOn?: string;
//   fromCity: string;
//   toCity: string;
//   deliveryType: DeliveryType;
// }

// const dummyOrders: OrderStatus[] = [
//   {
//     lrn: 'LRN001234',
//     status: 'pickup',
//     pickupDate: '2025-12-05',
//     estimatedDelivery: '2025-12-08',
//     fromCity: 'Delhi',
//     toCity: 'Jaipur',
//     deliveryType: 'GODOWN_DELIVERY',
//   },
//   {
//     lrn: 'LRN005678',
//     status: 'intransit',
//     pickupDate: '2025-12-03',
//     estimatedDelivery: '2025-12-06',
//     fromCity: 'Noida',
//     toCity: 'Ludhiana',
//     deliveryType: 'DOOR_DELIVERY',
//   },
//   {
//     lrn: 'LRN009012',
//     status: 'delivered',
//     pickupDate: '2025-12-01',
//     deliveredOn: '2025-12-03',
//     fromCity: 'Gurgaon',
//     toCity: 'Mumbai',
//     deliveryType: 'DOOR_DELIVERY',
//   },
// ];

// const TrackingScreen: React.FC = () => {
//   const [lrnInput, setLrnInput] = useState('');
//   const [trackingResult, setTrackingResult] = useState<OrderStatus | null>(null);
//   const [notFound, setNotFound] = useState(false);
//   const [searched, setSearched] = useState(false);

//   const handleTrack = () => {
//     if (!lrnInput.trim()) return;

//     const order = dummyOrders.find(
//       o => o.lrn.toLowerCase() === lrnInput.trim().toLowerCase()
//     );

//     setSearched(true);
//     if (order) {
//       setTrackingResult(order);
//       setNotFound(false);
//     } else {
//       setTrackingResult(null);
//       setNotFound(true);
//     }
//   };

//   const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
//     if (e.key === 'Enter') handleTrack();
//   };

//   const formatDate = (dateString?: string) => {
//     if (!dateString) return '-';
//     const d = new Date(dateString);
//     return d.toLocaleDateString('en-IN', {
//       day: 'numeric',
//       month: 'short',
//       year: 'numeric',
//     });
//   };

//   const currentStep = (status: Status) => {
//     if (status === 'pickup') return 1;
//     if (status === 'intransit') return 2;
//     if (status === 'delivered') return 3;
//     return 0;
//   };

//   const getDeliveryTypeLabel = (deliveryType: DeliveryType) =>
//     deliveryType === 'GODOWN_DELIVERY' ? 'Godown delivery' : 'Door delivery';

//   return (
//     <div className="tracking-page">
//       <div className="tracking-header">
//         <h1 className="tracking-title">Track shipment</h1>
//         <p className="tracking-subtitle">
//           Check live status, route and expected delivery for your Instaship load.
//         </p>
//       </div>

//       <div className="tracking-search-card">
//         <div className="search-row">
//           <input
//             type="text"
//             className="lrn-input"
//             placeholder="Enter LRN number"
//             value={lrnInput}
//             onChange={e => setLrnInput(e.target.value.toUpperCase())}
//             onKeyDown={handleKeyDown}
//           />
//           <button className="track-button" onClick={handleTrack}>
//             Track
//           </button>
//         </div>
//         {searched && (
//           <button
//             className="reset-button"
//             onClick={() => {
//               setLrnInput('');
//               setTrackingResult(null);
//               setNotFound(false);
//               setSearched(false);
//             }}
//           >
//             Clear
//           </button>
//         )}
//       </div>

//       {notFound && (
//         <div className="status-card not-found">
//           <h3>Shipment not found</h3>
//           <p>
//             No shipment could be found for LRN <strong>{lrnInput}</strong>.
//           </p>
//           <p>
//             Please verify the LRN or contact{' '}
//             <a href="mailto:support@instaship.co.in">support@instaship.co.in</a>.
//           </p>
//         </div>
//       )}

//       {trackingResult && (
//         <div className="status-card">
//           <div className="status-top-row">
//             <div className="status-pill">
//               {trackingResult.status === 'delivered'
//                 ? '✓ Delivered'
//                 : trackingResult.status === 'intransit'
//                 ? '🚚 In transit'
//                 : '📦 Pickup scheduled'}
//             </div>
//             <div className="lrn-chip">LRN • {trackingResult.lrn}</div>
//           </div>

//           {/* Route chip */}
//           <div className="route-chip">
//             <div className="route-locations">
//               <div className="route-location-item">
//                 <span className="route-location-label">From</span>
//                 <span className="route-location-city">{trackingResult.fromCity}</span>
//               </div>
//               <div className="route-arrow-container">
//                 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="route-arrow-icon">
//                   <path d="M5 12h14m-6-6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//                 </svg>
//               </div>
//               <div className="route-location-item">
//                 <span className="route-location-label">To</span>
//                 <span className="route-location-city">{trackingResult.toCity}</span>
//               </div>
//             </div>
//           </div>

//           {/* Premium timeline */}
//           <div className="timeline-container">
//             <div className="timeline-track">
//               <div 
//                 className="timeline-progress"
//                 style={{ 
//                   width: currentStep(trackingResult.status) === 1 ? '0%' : 
//                          currentStep(trackingResult.status) === 2 ? '50%' : '100%' 
//                 }}
//               />
//               <div className={`timeline-node ${currentStep(trackingResult.status) >= 1 ? 'active' : ''}`} style={{ left: '0%' }}>
//                 <div className="timeline-node-circle">
//                   {currentStep(trackingResult.status) > 1 ? '✓' : ''}
//                 </div>
//               </div>
//               <div className={`timeline-node ${currentStep(trackingResult.status) >= 2 ? 'active' : ''}`} style={{ left: '50%' }}>
//                 <div className="timeline-node-circle">
//                   {currentStep(trackingResult.status) > 2 ? '✓' : ''}
//                 </div>
//               </div>
//               <div className={`timeline-node ${currentStep(trackingResult.status) >= 3 ? 'active' : ''}`} style={{ left: '100%' }}>
//                 <div className="timeline-node-circle">
//                   {currentStep(trackingResult.status) === 3 ? '✓' : ''}
//                 </div>
//               </div>
//             </div>

//             <div className="timeline-labels">
//               <div className={`timeline-label-item ${currentStep(trackingResult.status) >= 1 ? 'active' : ''}`}>
//                 <div className="timeline-label-title">Pickup date</div>
//                 <div className="timeline-label-value">{formatDate(trackingResult.pickupDate)}</div>
//               </div>
//               <div className={`timeline-label-item ${currentStep(trackingResult.status) >= 2 ? 'active' : ''}`}>
//                 <div className="timeline-label-title">In transit</div>
//                 <div className="timeline-label-value">
//                   {currentStep(trackingResult.status) >= 2 ? 'Package is on its way' : 'Not yet dispatched'}
//                 </div>
//               </div>
//               <div className={`timeline-label-item ${currentStep(trackingResult.status) >= 3 ? 'active' : ''}`}>
//                 <div className="timeline-label-title">
//                   {trackingResult.status === 'delivered' ? 'Delivered on' : 'Estimated delivery by'}
//                 </div>
//                 <div className="timeline-label-value">
//                   {trackingResult.status === 'delivered'
//                     ? formatDate(trackingResult.deliveredOn)
//                     : formatDate(trackingResult.estimatedDelivery)}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Delivery info */}
//           <div className="delivery-info-section">
//             <div className="delivery-info-item">
//               <span className="delivery-info-label">Delivery type</span>
//               <span className="delivery-info-value">{getDeliveryTypeLabel(trackingResult.deliveryType)}</span>
//             </div>
//             <div className="delivery-info-item">
//               <span className="delivery-info-label">Expected by</span>
//               <span className="delivery-info-value">
//                 {trackingResult.status === 'delivered'
//                   ? formatDate(trackingResult.deliveredOn)
//                   : formatDate(trackingResult.estimatedDelivery)}
//               </span>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default TrackingScreen;






















import React, { useState, useEffect } from 'react';
import './TrackingScreen.css';
import { useParams, useSearchParams } from 'react-router-dom';

type DeliveryType = 'GODOWN_DELIVERY' | 'DOOR_DELIVERY';
type Status = 'pickup' | 'intransit' | 'delivered';

interface OrderStatus {
  lrn: string;
  status: Status;
  pickupDate: string;
  estimatedDelivery?: string;
  deliveredOn?: string;
  fromCity: string;
  toCity: string;
  deliveryType: DeliveryType;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const dummyOrders: OrderStatus[] = [
  {
    lrn: 'LRN001234',
    status: 'pickup',
    pickupDate: '2025-12-05',
    estimatedDelivery: '2025-12-08',
    fromCity: 'Delhi',
    toCity: 'Jaipur',
    deliveryType: 'GODOWN_DELIVERY',
  },
  {
    lrn: 'LRN005678',
    status: 'intransit',
    pickupDate: '2025-12-03',
    estimatedDelivery: '2025-12-06',
    fromCity: 'Noida',
    toCity: 'Ludhiana',
    deliveryType: 'DOOR_DELIVERY',
  },
  {
    lrn: 'LRN009012',
    status: 'delivered',
    pickupDate: '2025-12-01',
    deliveredOn: '2025-12-03',
    fromCity: 'Gurgaon',
    toCity: 'Mumbai',
    deliveryType: 'DOOR_DELIVERY',
  },
];

const TrackingScreen: React.FC = () => {
  const { lrn: lrnFromPath } = useParams<{ lrn?: string }>();
  const [searchParams] = useSearchParams();
  const [lrnInput, setLrnInput] = useState('');
  const [trackingResult, setTrackingResult] = useState<OrderStatus | null>(null);
  const [notFound, setNotFound] = useState(false);
  const [searched, setSearched] = useState(false);
  const [loading, setLoading] = useState(false);

  // Check for LRN in URL path or query params on component mount
  useEffect(() => {
    // Priority: path parameter > query parameter
    const lrnFromUrl = lrnFromPath || searchParams.get('lrn');
    
    if (lrnFromUrl && lrnFromUrl.trim() !== '') {
      const upperLrn = lrnFromUrl.toUpperCase();
      setLrnInput(upperLrn);
      // Trigger tracking automatically
      performTrack(upperLrn);
    }
  }, [lrnFromPath, searchParams]);

  const performTrack = async (lrn: string) => {
    if (!lrn || !lrn.trim()) return;

    setLoading(true);
    setSearched(true);

    try {
      const base = process.env.REACT_APP_BACKEND_API_ROUTE || '';
      const baseTrimmed = base.replace(/\/$/, '');
      const url = `${baseTrimmed}/orders/summary/${encodeURIComponent(lrn.trim().toUpperCase())}`;

      const res = await fetch(url, { method: 'GET' });

      if (!res.ok) {
        if (res.status === 404) {
          setTrackingResult(null);
          setNotFound(true);
          return;
        }
        const text = await res.text();
        throw new Error(`HTTP ${res.status}: ${text}`);
      }

      const data = await res.json();

      // backend may return { found: false } for missing records
      if (data && data.found === false) {
        setTrackingResult(null);
        setNotFound(true);
        return;
      }

      // Map backend response to OrderStatus
      const order: OrderStatus = {
        lrn: data.lrn || lrn,
        status: (data.status as Status) || 'intransit',
        pickupDate: data.pickupDate || data.orderedAt || '',
        estimatedDelivery: data.estimatedDelivery || undefined,
        deliveredOn: data.deliveredOn || undefined,
        fromCity: data.fromCity || '',
        toCity: data.toCity || '',
        deliveryType: data.deliveryType || (data.doorDeliveryProvided === 'YES' ? 'DOOR_DELIVERY' : 'GODOWN_DELIVERY'),
      };

      setTrackingResult(order);
      setNotFound(false);
    } catch (error) {
      console.error('Error fetching tracking data:', error);
      setTrackingResult(null);
      setNotFound(true);
    } finally {
      setLoading(false);
    }
  };


  const handleTrack = async () => {
    performTrack(lrnInput);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') handleTrack();
  };

  const formatDate = (dateString?: string) => {
    if (!dateString) return '-';
    const d = new Date(dateString);
    return d.toLocaleDateString('en-IN', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  };

  const currentStep = (status: Status) => {
    if (status === 'pickup') return 1;
    if (status === 'intransit') return 2;
    if (status === 'delivered') return 3;
    return 0;
  };

  const getDeliveryTypeLabel = (deliveryType: DeliveryType) =>
    deliveryType === 'GODOWN_DELIVERY' ? 'Godown delivery' : 'Door delivery';

  // If ETA is already in the past and order is still in transit, show today instead
  const getDisplayEta = (estimatedDelivery?: string): string => {
    if (!estimatedDelivery) return '-';
    const eta = new Date(estimatedDelivery);
    const today = new Date();
    eta.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return eta < today ? formatDate(today.toISOString().split('T')[0]) : formatDate(estimatedDelivery);
  };

  return (
    <div className="tracking-page">
      {/* ── Hero banner ────────────────────────────────────────── */}
      <div className="tracking-hero">
        <div className="tracking-hero-badge">
          <span className="tracking-hero-badge-dot" />
          Live Tracking
        </div>
        <h1 className="tracking-title">
          Track Your <span>Shipment</span>
        </h1>
        <p className="tracking-subtitle">
          Real-time status, route and estimated delivery — all in one place.
        </p>
      </div>

      {/* ── Search card (overlaps hero bottom) ─────────────────── */}
      <div className="tracking-search-wrapper">
        <div className="tracking-search-card">
          <div className="search-row">
            <input
              type="text"
              className="lrn-input"
              placeholder="Enter LRN number"
              value={lrnInput}
              onChange={e => setLrnInput(e.target.value.toUpperCase())}
              onKeyDown={handleKeyDown}
              disabled={loading}
            />
            <button className="track-button" onClick={handleTrack} disabled={loading}>
              {loading ? 'Tracking…' : 'Track'}
            </button>
          </div>
          {searched && !loading && (
            <button
              className="reset-button"
              onClick={() => {
                setLrnInput('');
                setTrackingResult(null);
                setNotFound(false);
                setSearched(false);
              }}
            >
              Clear
            </button>
          )}
        </div>
      </div>

      {/* ── Results ────────────────────────────────────────────── */}
      <div className="tracking-body">
        {loading && (
          <div className="status-card">
            <p style={{ textAlign: 'center' }}>Loading tracking information…</p>
          </div>
        )}

        {!loading && notFound && (
          <div className="status-card not-found">
            <h3>Shipment not found</h3>
            <p>
              No shipment could be found for LRN <strong>{lrnInput}</strong>.
            </p>
            <p>
              Please verify the LRN or contact{' '}
              <a href="mailto:support@instaship.co.in">support@instaship.co.in</a>.
            </p>
          </div>
        )}

        {!loading && trackingResult && (
          <div className="status-card">
            <div className="status-top-row">
              <div className="status-pill">
                {trackingResult.status === 'delivered'
                  ? '✓ Delivered'
                  : trackingResult.status === 'intransit'
                  ? '🚚 In transit'
                  : '📦 Pickup scheduled'}
              </div>
              <div className="lrn-chip">LRN • {trackingResult.lrn}</div>
            </div>

            {/* Route chip */}
            <div className="route-chip">
              <div className="route-locations">
                <div className="route-location-item route-location-left">
                  <span className="route-location-label">From</span>
                  <span className="route-location-city">{trackingResult.fromCity}</span>
                </div>
                <div className="route-arrow-container">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="route-arrow-icon">
                    <path d="M5 12h14m-6-6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="route-location-item route-location-right">
                  <span className="route-location-label">To</span>
                  <span className="route-location-city">{trackingResult.toCity}</span>
                </div>
              </div>
            </div>

            {/* Timeline */}
            <div className="timeline-container">
              <div className="timeline-track">
                <div 
                  className="timeline-progress"
                  style={{ 
                    width: currentStep(trackingResult.status) === 1 ? '0%' : 
                           currentStep(trackingResult.status) === 2 ? '50%' : '100%' 
                  }}
                />
                <div className={`timeline-node ${currentStep(trackingResult.status) >= 1 ? 'active' : ''}`} style={{ left: '4%' }}>
                  <div className="timeline-node-circle">
                    {currentStep(trackingResult.status) > 1 ? '✓' : ''}
                  </div>
                </div>
                <div className={`timeline-node ${currentStep(trackingResult.status) >= 2 ? 'active' : ''}`} style={{ left: '50%' }}>
                  <div className="timeline-node-circle">
                    {currentStep(trackingResult.status) > 2 ? '✓' : ''}
                  </div>
                </div>
                <div className={`timeline-node ${currentStep(trackingResult.status) >= 3 ? 'active' : ''}`} style={{ left: '96%' }}>
                  <div className="timeline-node-circle">
                    {currentStep(trackingResult.status) === 3 ? '✓' : ''}
                  </div>
                </div>
              </div>

              <div className="timeline-labels">
                <div className={`timeline-label-item ${currentStep(trackingResult.status) >= 1 ? 'active' : ''}`}>
                  <div className="timeline-label-title">Pickup date</div>
                  <div className="timeline-label-value">{formatDate(trackingResult.pickupDate)}</div>
                </div>
                <div className={`timeline-label-item ${currentStep(trackingResult.status) >= 2 ? 'active' : ''} ${trackingResult.status === 'delivered' ? 'timeline-label-hidden-mobile' : ''}`}>
                  <div className="timeline-label-title">In transit</div>
                  <div className="timeline-label-value">
                    {trackingResult.status === 'delivered' ? 'Dispatched' : currentStep(trackingResult.status) >= 2 ? 'Package is on its way' : 'Not yet dispatched'}
                  </div>
                </div>
                <div className={`timeline-label-item ${currentStep(trackingResult.status) >= 3 ? 'active' : ''}`}>
                  <div className="timeline-label-title">
                    {trackingResult.status === 'delivered' ? 'Delivered on' : 'Estimated delivery by'}
                  </div>
                  <div className="timeline-label-value">
                    {trackingResult.status === 'delivered'
                      ? formatDate(trackingResult.deliveredOn)
                      : getDisplayEta(trackingResult.estimatedDelivery)}
                  </div>
                </div>
              </div>
            </div>

            {/* Delivery info */}
            <div className="delivery-info-section">
              <div className="delivery-info-item">
                <span className="delivery-info-label">Delivery type</span>
                <span className="delivery-info-value">{getDeliveryTypeLabel(trackingResult.deliveryType)}</span>
              </div>
              <div className="delivery-info-item">
                <span className="delivery-info-label">
                  {trackingResult.status === 'delivered' ? 'Delivered on' : 'Expected by'}
                </span>
                <span className="delivery-info-value">
                  {trackingResult.status === 'delivered'
                    ? formatDate(trackingResult.deliveredOn)
                    : getDisplayEta(trackingResult.estimatedDelivery)}
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TrackingScreen;
